<router-outlet></router-outlet>
<app-update-prompt />
